// // src/index.js USES REACT ROUTER AND REDUX
// // Bootstrap CSS + JS (prod minified)

// test listener froom chatgpt
window.addEventListener('error', e => {
  console.error('window.onerror:', e.message, e.error);
});
window.addEventListener('unhandledrejection', e => {
  console.error('unhandledrejection:', e.reason);
});



console.log("index.js loaded")
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
window.bootstrap = bootstrap; // <-- Explicitly attach to window

import './index.css';

import React, { Component } from 'react'; // optional in React 18 but fine to keep
import ReactDOM from 'react-dom'; // created by react with 'render' method
// REDUX
import { Provider } from 'react-redux';
//import { HistoryRouter } from 'redux-first-history/rr6'; // grok says wk/s w/ @4.0.3
import { BrowserRouter } from 'react-router-dom';
//import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history'; // history is a package
import {store } from './store'; //  this matches store as default in store.js
import Auth0ProviderWithNavigate from './utils/Auth0ProviderWithNavigate';

import App from './components/App/App';
//import AuthService from './utils/AuthService'; / /dont need in new auth0 code
import Globals from './utils/globals';
//const auth = new AuthService(Globals.auth0Client, Globals.auth0Domain);

// This is from grk3 new code for REACT debug

console.log(" in index.js before class RootErrorBoundary");
class RootErrorBoundary extends Component {
 
  state = { error: null };

  static getDerivedStateFromError(error) {
    console.error('RootErrorBoundary - Caught error:', error);
    return { error };
  }

  render() {
    if (this.state.error) {
      return <div>Error from Index.js: {this.state.error.message}</div>;
    }
    return this.props.children;
  }
}

console.log(" in index.js after class RootErrorBoundary")
try {
  const history = createBrowserHistory();
  console.log('index.js - Initializing app');
  console.log('index.js - Store state:', store.getState());
  console.log('index.js - History object:', history);
  console.log('index.js - History action:', history?.action || 'action is undefined');
  console.log('index.js - History location:', history?.location || 'location is undefined');
  console.log('index.js - History keys:', history ? Object.keys(history) : 'history is undefined');
  console.log('index.js - History action type:', history?.action ? typeof history.action : 'action is undefined');
  console.log('index.js - History location type:', history?.location ? typeof history.location : 'location is undefined');
  // this is for react 17 and new auth0 plugin. note react creates a 'render' METHOD on React.DOM
ReactDOM.render(
    <RootErrorBoundary>
      
      <Provider store={store}>
        <BrowserRouter>
        {/* <HistoryRouter history={history}> */}
          <Auth0ProviderWithNavigate>
            <App />
          </Auth0ProviderWithNavigate>
        {/* </HistoryRouter> */}
        </BrowserRouter>
      </Provider>
      
    </RootErrorBoundary>,
    document.getElementById('root')
);

console.log('index.js - Rendering React app...');
} catch (error) {
  console.error('index.js - Error:', error);
}

// THIS WAS FOR REACT 18  
//   const root = createRoot(document.getElementById('root'));
//   console.log('xt Rendering React app...');
//   root.render(
//     <Provider store={store}>
//       <BrowserRouter>
//         <App auth={auth} />
//       </BrowserRouter>
//     </Provider>
//   );
// } catch (error) {
//   console.error('index.js - error:', error);


